/* Soulskart search-dropdown FAQ answers.

   WHAT THIS IS
   Matching FAQ questions as tappable pills, BELOW the product results. Tapping
   one opens its answer inline, in the dropdown. Tapping it again closes it.
   The last pill, Visit FAQ, goes to the page.

   WHY INLINE ANSWERS ARE OK NOW AND WERE NOT BEFORE
   An early build auto-expanded the top answer ABOVE the products on every
   keystroke. That buried the products and turned a search box into a help
   centre. This is the opposite: nothing expands until the shopper asks for it,
   and it opens underneath the products, never over them. One answer at a time.

   PROGRESSIVE ENHANCEMENT
   The pills are real anchors to /pages/faq#anchor. Only a plain left click is
   intercepted — cmd, ctrl, shift, alt and middle clicks still open the FAQ page
   the way the shopper expects, and with JS off every pill is a working link.

   MOUNTING IS THE THEME'S JOB, NOT THIS FILE'S.
   The strip element is rendered by Liquid in snippets/ss-inline-search.liquid,
   inside .ss-pse__content-area, AFTER ref=predictiveSearchResults. That ref is
   the only node predictive-search.js morphs, so the strip is never wiped and
   never has to be re-homed. Nothing here creates, inserts, moves or observes
   DOM outside its own panel. The first build injected a panel from outside the
   theme and raced the morph; it mounted beside the dropdown.

   WHEN IT HIDES
   Two rules, both declarative:
   - no question-intent match: this file sets the hidden attribute;
   - Shopify already returned Pages results: pure CSS in the snippet, via
     :has([data-resource-type=page]). No observer, no timing.

   THE ANSWER FETCH
   Answer bodies are read from /pages/faq, once per page load, and only after a
   help query has actually matched — so a shopper who never types a question
   never pays for it. Edit the FAQ page and the answers follow on the next load
   with no rebuild. Question wording and anchor ids still come from
   ss-help-data-*.js, so those drift until build_help_search.py is re-run.

   Load order: data-a, data-b, tables, match, ui. */
(function () {
  var S = window.SS_HELP;
  if (!S || !S.search || window.__ssHelpUi) return;
  window.__ssHelpUi = true;

  var FAQ_URL = '/pages/faq';
  var DATA = S.DATA;
  var search = S.search;
  var MIN_CHARS = 3;
  var seq = 0;

  function el(tag, cls) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    return node;
  }

  /* ---------------- answers, read from the FAQ page --------------------- */
  var answers = null;
  var fetching = null;

  function loadAnswers() {
    if (answers) return Promise.resolve(answers);
    if (fetching) return fetching;
    if (!window.fetch || !window.DOMParser) return Promise.resolve(null);
    fetching = fetch(FAQ_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (txt) {
        if (!txt) return null;
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var map = {};
        var items = doc.querySelectorAll('details.sk-faq__item');
        for (var i = 0; i < items.length; i++) {
          var body = items[i].querySelector('.sk-faq__ans');
          if (items[i].id && body) map[items[i].id] = body.innerHTML;
        }
        answers = map;
        return map;
      })
      .catch(function () { return null; });
    return fetching;
  }

  /* ---------------- rendering ------------------------------------------- */
  function fill(box, id) {
    box.textContent = '';

    var body = el('div', 'ss-help__ans');
    box.appendChild(body);

    var link = el('a', 'ss-help__read');
    link.href = FAQ_URL + '#' + id;
    link.textContent = 'Read on the FAQ page';
    box.appendChild(link);

    if (answers && answers[id]) {
      body.innerHTML = answers[id];
      return;
    }
    /* Usually already warm — the fetch starts the moment the strip renders. */
    var wait = el('p', 'ss-help__wait');
    wait.textContent = 'Loading…';
    body.appendChild(wait);
    loadAnswers().then(function (map) {
      if (box.hidden) return;
      if (map && map[id]) { body.innerHTML = map[id]; return; }
      body.textContent = '';
      var miss = el('p');
      miss.textContent = 'Open this on the FAQ page for the full answer.';
      body.appendChild(miss);
    });
  }

  function toggle(panel, pill) {
    var box = panel.querySelector('.ss-help__a');
    if (!box) return;
    var wasOpen = pill.getAttribute('aria-expanded') === 'true';
    var pills = panel.querySelectorAll('.ss-help__q');
    for (var i = 0; i < pills.length; i++) pills[i].setAttribute('aria-expanded', 'false');

    if (wasOpen) { box.hidden = true; box.textContent = ''; return; }
    pill.setAttribute('aria-expanded', 'true');
    box.hidden = false;
    fill(box, pill.getAttribute('data-for'));
  }

  function render(panel, hits) {
    panel.textContent = '';

    /* Mono caps with a lime tick — the label idiom used across the storefront. */
    var head = el('p', 'ss-help__hd');
    head.textContent = 'Quick answers';
    panel.appendChild(head);

    var boxId = 'ss-help-a-' + (++seq);
    var list = el('ul', 'ss-help__list');

    for (var i = 0; i < hits.length; i++) {
      var it = hits[i].item;
      var li = el('li');
      var a = el('a', 'ss-help__q');
      a.href = FAQ_URL + '#' + it.i;
      a.setAttribute('data-for', it.i);
      a.setAttribute('aria-expanded', 'false');
      a.setAttribute('aria-controls', boxId);
      /* Questions carry HTML entities from the FAQ page, so they go in as
         markup. They are authored content, not shopper input. */
      a.innerHTML = it.q;
      li.appendChild(a);
      list.appendChild(li);
    }

    /* Last pill, so it wraps into the same flow rather than sitting alone. */
    var moreLi = el('li');
    var more = el('a', 'ss-help__more');
    more.href = FAQ_URL;
    more.textContent = 'Visit FAQ';
    moreLi.appendChild(more);
    list.appendChild(moreLi);
    panel.appendChild(list);

    var box = el('div', 'ss-help__a');
    box.id = boxId;
    box.hidden = true;
    panel.appendChild(box);

    /* Warm the cache now, so the first pill tap is instant. Only help queries
       ever reach this line. */
    loadAnswers();
  }

  /* ---------------- the strip ------------------------------------------- */
  function rootFor(node) {
    if (!node || !node.closest) return null;
    return node.closest('predictive-search-component') || node.closest('form');
  }

  function panelFor(root) {
    return root ? root.querySelector('[data-ss-help]') : null;
  }

  function clearPanel(root) {
    var panel = panelFor(root);
    if (!panel) return;
    panel.hidden = true;
    panel.textContent = '';
  }

  /* One delegated handler per panel, bound once. render() rebuilds the pills on
     every keystroke, so per-pill listeners would be re-attached constantly. */
  function bindPanel(panel) {
    if (panel.__ssBound) return;
    panel.__ssBound = true;
    panel.addEventListener('click', function (e) {
      var pill = e.target.closest ? e.target.closest('.ss-help__q') : null;
      if (!pill || !panel.contains(pill)) return;
      /* Let modified and middle clicks open the FAQ page as the shopper
         expects. Only a plain left click opens the answer inline. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      toggle(panel, pill);
    });
  }

  function update(input) {
    var root = rootFor(input);
    var panel = panelFor(root);
    if (!panel) return;
    bindPanel(panel);

    var v = (input.value || '').trim();
    var hits = v.length < MIN_CHARS ? [] : search(v);

    if (!hits.length) { clearPanel(root); return; }
    render(panel, hits);
    panel.hidden = false;
  }

  /* ---------------- wiring ---------------------------------------------- */
  /* Delegated on document, so both instances of the snippet (desktop bar and
     mobile row) and any re-rendered header section are covered without a
     rescan. The timer lives on the input, so the two bars debounce
     independently. */
  function isSearchInput(node) {
    return !!node && node.tagName === 'INPUT' && node.name === 'q';
  }

  function schedule(input) {
    if (input.__ssT) clearTimeout(input.__ssT);
    input.__ssT = setTimeout(function () { update(input); }, 90);
  }

  document.addEventListener('input', function (e) {
    if (isSearchInput(e.target)) schedule(e.target);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (isSearchInput(e.target)) update(e.target);
  }, true);

  /* Clear and Escape empty the box without firing an input event, so the strip
     has to be told. Do NOT re-read input.value here: Horizon debounces its own
     resetSearch by 100ms, so straight after the click the value is still the
     old query and the strip stayed up. Measured. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.predictive-search__reset-button') : null;
    if (btn) clearPanel(rootFor(btn));
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isSearchInput(e.target)) clearPanel(rootFor(e.target));
  }, true);
})();